module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-22-c25fe2403c2faf0d425bce6909baa111.png";